<template>

  <div class="common-seach-wrap">
    <el-tabs v-model="depositName">
      <el-tab-pane label="保证金" name="first"></el-tab-pane>
      <el-tab-pane label="保证金记录" name="second"></el-tab-pane>
    </el-tabs>
    <Deposit v-if="depositName == 'first'"></Deposit>
    <Record v-if="depositName == 'second'"></Record>
  </div>
</template>
<script>
import Deposit from './part/deposit';
import Record from './part/record';
export default {
  components: {
    Deposit,
    Record
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      form: {
        status: 0
      },
      depositName: 'first'
    };
  },
  methods: {}
};
</script>

<style>
.operation-wrap {
  height: 124px;
  border-radius: 8px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 30px 30px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  overflow: hidden;
  background: #909399;
  background-size: 100% 100%;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/deposit/index.vue